<template>
  <div class="managementBox">
    <!-- 头部筛选 -->
    <div class="filterBox">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="投票状态:" class="filterBox_label">
          <el-select v-model="form.status" placeholder="请选择" @focus="selectFocus">
            <el-option :label="item" :value="i" v-for="(item, i) in status_name_map" :key="i" />
          </el-select>
        </el-form-item>
        <el-form-item label="关键词:" @keydown.enter.native="onSubmit">
          <el-input v-model="form.keyword" :clearable="true" class="filterBox_input" />
        </el-form-item>
        <el-form-item>
          <el-button class="filterButton" type="primary" @click="onSubmit">筛选</el-button>
          <el-button class="filterButton" type="primary" @click="newVote()">新建投票</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      class="my-table"
      v-loading="tableLoading"
      :header-cell-style="styleObj"
    >
      <template slot="empty">
        <!-- 没有数据 -->
        <div class="table-noData">
          <img class="table-noData-img" :src="g_imgSrc.bgWhite" />
          <div class="table-noData-word">暂无相关内容</div>
        </div>
      </template>
      <el-table-column prop="name" label="投票名称"></el-table-column>
      <el-table-column prop="total_voter_num" label="参与人数"></el-table-column>
      <el-table-column prop="status" label="投票状态">
        <template scope="scope">
          {{ status_name_map[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click="operationEmit(scope, '详情')"
            type="text"
            v-if="scope.row.status != 1"
            :disabled="scope.row.status === 99 ? 'disabled' : false"
          >
            详情
          </el-button>
          <el-button
            @click="operationEmit(scope, '编辑')"
            type="text"
            v-if="scope.row.status === 1"
            :disabled="scope.row.status === 99 ? 'disabled' : false"
          >
            编辑
          </el-button>
          <el-button
            @click="operationEmit(scope, '删除')"
            type="text"
            :disabled="scope.row.status === 99 ? 'disabled' : false"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_list_page">
      <el-pagination
        class="release-pagination"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :current-page="form.tablePageIndex"
        @current-change="handleCurrentChanges"
        :page-sizes="g_pageSizesConfig"
        :page-size="form.tablePageSize"
        :total="tableTotal"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { GetVoteListApi, DelVoteApi, GetVoteStatusCfgApi } from '@/api/releaseManagement';
export default {
  name: 'VotingManagement',
  components: {},
  data() {
    return {
      form: {
        // 筛选栏
        status: '0',
        keyword: '',
        tablePageSize: 10, // 每页显示条数
        tablePageIndex: 1, // 表格当前页码
      },
      tableLoading: false, // 表格加载
      row: {}, // 暂存表格行(删除操作要用到当前点击的行数据)
      tableData: [], // 表格数据
      tableTotal: 0, // 总条数
      status_name_map: {}, // 投票枚举状态
      styleObj: {
        background: '#f5f7fa', // 表头颜色
      },
    };
  },
  created() {
    // 初始加载列表及状态
    this.getTableList();
    this.GetVoteStatusCfgApi();
  },
  mounted() {},
  methods: {
    // 状态选择获取焦点事件
    selectFocus() {
      // 如果页面初始获取状态未成功，选择时重新获取
      if (!this.status_name_map) {
        this.GetVoteStatusCfgApi();
      }
    },
    // 读取投票状态枚举
    GetVoteStatusCfgApi() {
      GetVoteStatusCfgApi()
        .then((res) => {
          if (res) {
            this.status_name_map = res.status_name_map;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 点击筛选按钮事件
    onSubmit() {
      this.form.tablePageIndex = 1;
      this.getTableList();
    },
    // 点击操作行 回调事件
    operationEmit(e, name) {
      const { row } = e;
      this.row = row;
      console.log(e);
      switch (name) {
        case '删除':
          this.dialogEmit('删除后数据无法恢复，且文章消息中不再显示', '确定删除该投票吗？');
          break;
        case '详情':
          this.g_tourl(`/saas/voteManagement/votingDetail.html?date=${e.row.vote_id}`, {
            open: true,
          });
          break;
        case '编辑':
          this.g_tourl(`/saas/voteManagement/addVoting.html?date=${e.row.vote_id}`, {
            open: true,
          });
          break;
        default:
          break;
      }
    },
    // 获取分页查询投票列表
    async getTableList() {
      this.tableLoading = true;
      const query = {
        page_index: this.form.tablePageIndex,
        page_size: this.form.tablePageSize,
        status: this.form.status,
        keyword: this.form.keyword,
      };
      try {
        GetVoteListApi(query)
          .then((res) => {
            if (res) {
              const arrTemp = res.vote_list ? res.vote_list : [];
              this.tableData = arrTemp;
              this.tableTotal = res.total;
              this.tableLoading = false;
              if (arrTemp.length === 0 && query.page_index > 1) {
                this.form.tablePageIndex = 1;
                this.getTableList();
              }
            }
          })
          .catch((err) => {
            this.$message.error(err);
            this.tableLoading = false;
          });
      } catch (error) {
        this.$message.error(error);
        this.tableLoading = false;
        this.$message('网络请求失败, 请稍后再试');
      }
    },
    // 切换页面回调事件
    paginationEmit(e) {
      this.pageIndex = e;
      this.getTableList();
    },
    // 新建投票
    newVote() {
      this.row = {};
      this.g_tourl(`/saas/voteManagement/addVoting.html`, {
        open: true,
      });
    },
    // 详情有修改 重置表格
    changeDetailEmit() {
      this.resettingDefaultStatus();
    },
    // 对话框回调事件确认删除投票信息
    async dialogEmit(text, title) {
      this.$confirm(text, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.delete();
        })
        .catch(() => {});
    },
    delete() {
      const req = {
        vote_id: this.row.vote_id,
      };
      DelVoteApi(req)
        .then((res) => {
          if (res) {
            this.$message.success('删除成功');
          }
          this.getTableList();
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 重置默认状态
    resettingDefaultStatus() {
      this.form = {
        status: '0',
        keyword: '',
      };
      this.form.tablePageIndex = 1;
      this.getTableList();
    },
    // 列表选择页
    handleCurrentChanges(val) {
      this.form.tablePageIndex = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.form.tablePageIndex = 1;
      this.form.tablePageSize = val;
      this.getTableList();
    },
  },
};
</script>
<style lang="scss" scoped>
.filterBox {
  padding-bottom: 20px;
  .el-form-item {
    height: 48px;
    margin-bottom: 0;
    .el-form-item__label {
      height: 48px;
    }
    .filterButton {
      height: 48px;
    }
  }
}
.addVoting {
  height: 80px;
  line-height: 80px;
  text-align: right;
}
.my-table.el-table {
  min-height: 500px;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  //无数据
  .table-noData {
    width: 100%;
    height: 100%;
    text-align: center;

    .table-noData-img {
      width: 240px;
      height: 192px;
      margin-top: 100px;
    }

    .table-noData-word {
      height: 22px;
      margin-bottom: 80px;
      font-size: 16px;
      color: #909399;
      text-align: center;
    }
  }
}
.table_list_page {
  height: 50px;
  margin-top: 20px;
  text-align: right;
}
::v-deep {
  // .table_list_page .el-input__inner {
  //   width: 45px !important;
  // }
  .filterBox input {
    height: 48px !important;
    -webkit-user-select: text;
  }
  .filterBox .el-form-item__label {
    height: 48px;
    line-height: 48px;
  }
}
</style>
